import { defineMessage } from 'services/localization';

export const messages = {
    transactionNumberFieldText: defineMessage('transaction_number'),
    transactionReferenceFieldText: defineMessage('reference'),
    termsFieldText: defineMessage('terms'),
    dueDateFieldText: defineMessage('due_date'),
    transactionDateFieldText: defineMessage('date'),
    postingPeriodFieldText: defineMessage('posting_period'),
    memoFieldText: defineMessage('memo'),
    opportunityFieldText: defineMessage('opportunity'),
    excludeCommissionsFieldText: defineMessage('exclude_commissions'),
    partnerFieldText: defineMessage('partner'),
    salesRepFieldText: defineMessage('sales_rep_1'),
    leadSourceFieldText: defineMessage('lead_source'),
    salesEffectiveDateFieldText: defineMessage('sales_effective_date'),
    departmentFieldText: defineMessage('department'),
    classFieldText: defineMessage('class'),
    locationFieldText: defineMessage('location'),
    startDateFieldText: defineMessage('start_date'),
    endDateFieldText: defineMessage('end_date'),
    discountAmountFieldText: defineMessage('discount_amount'),
    discountDateFieldText: defineMessage('discount_date'),
    discountItemFieldText: defineMessage('discount_item'),
    discountRateFieldText: defineMessage('discount_rate'),
    excludeCommissionsPositiveValue: defineMessage('yes'),
};
